import { render, staticRenderFns } from "./BaseSegmento.vue?vue&type=template&id=ee8cdeda&scoped=true"
import script from "./BaseSegmento.vue?vue&type=script&lang=js"
export * from "./BaseSegmento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8cdeda",
  null
  
)

export default component.exports